<div class="sheet">
  @if (loading) {
    <div class="excel-table">
      <app-loader></app-loader>
    </div>
  } @else {
    <table class="excel-table">
      <thead>
        <tr>
          <th colspan="1">
            @if (refreshDataTrigger) {
              <div class="flex flex-row items-center justify-center">
                <mat-icon
                  class="filter"
                  [class.active-filter]="filterApplied"
                  (click)="filter()"
                  >filter_list</mat-icon
                >
                <button
                  mat-button
                  [matTooltip]="
                    'Last refreshed at ' +
                    (refreshedDataTime | date: 'd MMM yy, h:mm a')
                  "
                  (click)="refreshData()"
                >
                  <div class="flex flex-row items-center gap-2 refreshed">
                    <mat-icon class="refresh">{{
                      polling ? 'autorenew' : 'refresh'
                    }}</mat-icon>
                    <span>Refresh table</span>
                  </div>
                </button>
              </div>
            }
          </th>
          @for (group of groupedThemes; track group) {
            <th
              class="theme-header"
              data-test-id="data-sheet-theme-header"
              [attr.colspan]="getDisplayQuestions(group).length || 1"
            >
              {{ group.theme }}
            </th>
          }
        </tr>
        <tr class="header-row">
          <th>Expert</th>
          @for (group of groupedThemes; track group; let groupIndex = $index) {
            @for (question of getDisplayQuestions(group); track question) {
              <th
                [attr.data-test-id]="'data-sheet-question-header-' + groupIndex"
                [class.suggested-question-header]="
                  question.suggestion_status === 'suggested'
                "
                [matTooltip]="question.question"
              >
                <div class="header-cell">
                  @if (question.suggestion_status === 'suggested') {
                    <div class="suggested-badge-row">
                      <span class="suggested-badge">Suggested</span>
                    </div>
                  }
                  <div
                    class="question-content"
                    data-test-id="data-sheet-question-content"
                  >
                    <span
                      >Q{{ question.numberNotation }}.
                      {{ question.question }}</span
                    >
                  </div>
                  @if (question.suggestion_status === 'suggested') {
                    <div class="suggestion-action-row">
                      <button
                        type="button"
                        class="suggestion-action-btn approve"
                        matTooltip="Approve suggestion"
                        (click)="
                          updateSuggestionStatus(
                            question.question_id,
                            'approved'
                          );
                          $event.stopPropagation()
                        "
                      >
                        <mat-icon>check</mat-icon>
                      </button>
                      <button
                        type="button"
                        class="suggestion-action-btn decline"
                        matTooltip="Decline suggestion"
                        (click)="
                          updateSuggestionStatus(
                            question.question_id,
                            'declined'
                          );
                          $event.stopPropagation()
                        "
                      >
                        <mat-icon>close</mat-icon>
                      </button>
                    </div>
                  }
                </div>
              </th>
            }
          }
        </tr>
      </thead>
      <tbody>
        @for (
          respondent of filteredRespondents;
          track trackRespondent($index, respondent)
        ) {
          <tr>
            <td
              class="respondent"
              data-test-id="data-sheet-respondent"
              (click)="viewRespondent(respondent)"
            >
              <div data-test-id="data-sheet-table-cell-content">
                <a> {{ respondent.firstName }} {{ respondent.lastName }} </a>
                @if (
                  sheetHeaders.geography ||
                  sheetHeaders.profile_type ||
                  sheetHeaders.date_and_time_of_call
                ) {
                  <br />
                }
                @if (sheetHeaders.geography && !sheetHeaders.profile_type) {
                  <span>{{ respondent.geography }}</span
                  ><br />
                }
                @if (!sheetHeaders.geography && sheetHeaders.profile_type) {
                  <span>{{ respondent.segment }}</span
                  ><br />
                }
                @if (sheetHeaders.geography && sheetHeaders.profile_type) {
                  <span
                    >{{ respondent.geography }} - {{ respondent.segment }}</span
                  ><br />
                }
                @if (sheetHeaders.date_and_time_of_call) {
                  <span>{{
                    respondent.callDate | date: 'd MMM y, h:mm a'
                  }}</span
                  ><br />
                }
                @if (sheetHeaders.respondent_source) {
                  <span>
                    {{
                      respondent.type === 'techspert'
                        ? 'Techspert'
                        : respondent.source
                    }}
                  </span>
                }
              </div>
              @if (respondent.type === 'other') {
                <div class="action-container flex flex-row gap-2">
                  <mat-icon
                    matTooltip="Delete"
                    (click)="
                      deleteRespondent(respondent); $event.stopPropagation()
                    "
                  >
                    close
                  </mat-icon>
                </div>
              }
            </td>
            @for (group of groupedThemes; track group) {
              @for (question of getDisplayQuestions(group); track question) {
                <td
                  class="question"
                  [class.suggested-question-cell]="
                    question.suggestion_status === 'suggested'
                  "
                  [class.attribution-highlight]="
                    isAnswerAttributed(
                      respondent.respondentId,
                      question.question_id
                    )
                  "
                >
                  @let answer = respondent.answers[question.question_id];
                  @if (answer) {
                    <span data-test-id="data-sheet-table-cell-content">
                      @if (!answer.editing) {
                        <span>
                          {{
                            answer.answer | respondentAnswer: answer.citation
                          }}
                        </span>
                      } @else {
                        <div>
                          <mat-form-field
                            appearance="outline"
                            class="full-width"
                          >
                            <mat-label>Answer</mat-label>
                            <textarea
                              matInput
                              [(ngModel)]="answer.editedAnswer"
                            ></textarea>
                          </mat-form-field>
                        </div>
                      }
                    </span>
                  }
                  @if (dataCaptureSheetId && !answer) {
                    <span data-test-id="data-sheet-table-cell-content">
                      Processing
                    </span>
                  }
                  @if (!dataCaptureSheetId && !answer) {
                    <span data-test-id="data-sheet-table-cell-content">
                      ...
                    </span>
                  }
                  @if (answer) {
                    <div class="action-container flex flex-row gap-2">
                      @if (answer.editing) {
                        <mat-icon
                          matTooltip="Save"
                          (click)="saveAnswer(answer)"
                        >
                          check
                        </mat-icon>
                        <mat-icon
                          matTooltip="Cancel"
                          (click)="cancelEdit(answer)"
                        >
                          close
                        </mat-icon>
                      }
                      @if (!answer.editing && !answer.loading) {
                        <mat-icon
                          matTooltip="Regenerate answer"
                          (click)="regenerateAnswer(answer, respondent)"
                        >
                          refresh
                        </mat-icon>
                        <mat-icon
                          matTooltip="Edit in-line"
                          (click)="edit(answer)"
                        >
                          edit
                        </mat-icon>
                        <mat-icon
                          matTooltip="Copy"
                          (click)="copy(answer); $event.stopPropagation()"
                        >
                          copy
                        </mat-icon>
                      }
                      @if (answer.loading) {
                        <mat-icon> cloud_upload </mat-icon>
                      }
                    </div>
                  }
                  @if (answer) {
                    <div
                      class="flex flex-row flex-wrap items-center justify-center gap-2 mt-2"
                    >
                      @for (
                        citation of answer.citation;
                        track citation;
                        let i = $index
                      ) {
                        <button
                          type="button"
                          class="summary-citation-btn"
                          matTooltip="Open reference"
                          (click)="viewCitation(respondent, citation)"
                        >
                          Ref {{ i + 1 }}
                        </button>
                      }
                    </div>
                  }
                  @if (answer?.answer_method === 'manual') {
                    <div class="edited-container">
                      <mat-icon>edit_note</mat-icon>
                      <span>
                        Last edited:
                        {{ answer.created_at | date: 'd MMM yy, h:mm a' }}
                      </span>
                    </div>
                  }
                </td>
              }
            }
          </tr>
        }
        @if (showSummaryRow) {
          <tr class="summary-row">
            <td
              class="summary-label"
              data-test-id="data-sheet-table-cell-content"
            >
              Summary
            </td>
            @for (group of groupedThemes; track group) {
              @for (question of getDisplayQuestions(group); track question) {
                <td
                  class="summary-cell"
                  data-test-id="data-sheet-table-cell-content"
                >
                  @if (question.suggestion_status !== 'suggested') {
                    @let summary = summaries[question.question_id];
                    @if (summary) {
                      @if (summary.status === summaryStatus.Processing) {
                        <span> Processing </span>
                      }
                      @if (summary.status === summaryStatus.Processed) {
                        @if (summary.summary?.key_themes?.length) {
                          @for (
                            keyTheme of summary.summary.key_themes;
                            track trackSummaryTheme(themeIndex, keyTheme);
                            let themeIndex = $index
                          ) {
                            <div class="summary-theme">
                              <div class="summary-theme-header">
                                <span class="summary-theme-title">{{
                                  keyTheme.title
                                }}</span>
                                <button
                                  type="button"
                                  class="respondent-attribution-btn"
                                  matTooltip="Highlight attributed answers"
                                  [class.active]="
                                    isThemeAttributionActive(
                                      summary.question_id,
                                      themeIndex
                                    )
                                  "
                                  (click)="
                                    toggleThemeAttribution(
                                      summary.question_id,
                                      keyTheme,
                                      themeIndex
                                    );
                                    $event.stopPropagation()
                                  "
                                >
                                  ({{ keyTheme.respondent_count }})
                                </button>
                              </div>
                              @if (keyTheme.summary) {
                                <p class="summary-text">
                                  {{ keyTheme.summary }}
                                </p>
                              }
                              @for (
                                subTheme of keyTheme.sub_themes;
                                track subTheme
                              ) {
                                <div class="summary-sub-theme">
                                  <div class="summary-sub-theme-title">
                                    {{ subTheme.title }}
                                  </div>
                                  @if (subTheme.summary) {
                                    <p class="summary-text">
                                      {{ subTheme.summary }}
                                    </p>
                                  }
                                  @if (subTheme.quotes?.length) {
                                    <ul class="summary-quote-list">
                                      @for (
                                        quote of subTheme.quotes;
                                        track quote
                                      ) {
                                        <li>
                                          {{ quote.quote }}
                                          @for (
                                            reference of quote.references;
                                            track reference;
                                            let referenceIndex = $index
                                          ) {
                                            <button
                                              type="button"
                                              class="summary-citation-btn"
                                              matTooltip="Open reference"
                                              (click)="
                                                viewSummaryCitation(
                                                  quote,
                                                  reference
                                                );
                                                $event.stopPropagation()
                                              "
                                            >
                                              Ref {{ referenceIndex + 1 }}
                                            </button>
                                          }
                                        </li>
                                      }
                                    </ul>
                                  }
                                </div>
                              }
                            </div>
                          }
                        } @else {
                          -
                        }
                      }
                      @if (
                        summary.updated_at &&
                        summary.status === summaryStatus.Processed
                      ) {
                        <div class="summary-meta">
                          Created
                          {{ summary.updated_at | date: 'd MMM yy, h:mm a' }}
                        </div>
                      }
                    } @else {
                      -
                    }
                  } @else {
                    -
                  }
                </td>
              }
            }
          </tr>
        }
      </tbody>
    </table>
  }
</div>
